import Moderator from '@/models/bread/Moderator/sponsorship'

export default {
  key:'Sponsorship',
  name:{
    singular:'Sponsorship',
    plural:'Sponsorship',
  },
  parents:[
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}